import React, { useEffect, useState } from "react";
import { storage } from "../service/FirebaseConfig";

import "../assets/Creatives.css";

const Creatives = () => {
  const [imageUrls, setImageUrls] = useState([]);

  useEffect(() => {
    const storageRef = storage.ref();
    const folderRef = storageRef.child("creatives"); // Replace with your actual folder name

    folderRef
      .listAll()
      .then((result) => {
        const urlPromises = result.items.map((itemRef) =>
          itemRef.getDownloadURL()
        );
        return Promise.all(urlPromises);
      })
      .then((urls) => {
        console.log(urls);
        setImageUrls(urls);
      })
      .catch((error) => {
        console.error("Error fetching image URLs:", error);
      });
  }, []);

  return (
    <div className="Creatives-container">
      <div className="image-grid">
        {imageUrls.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`${index}`}
            className="CreativesImage"
          />
        ))}
      </div>
    </div>
  );
};

export default Creatives;
